import React from 'react';

const Footer = () => {
    return (
        <div>
            <hr className='bg-black text-black font-bold' />
            <p className='font-bold my-4'>Copyright@ 2022 Quiz Hunter</p>
            <div>

            </div>
        </div>
    );
};

export default Footer;